export const GlobalPropsCards = [
  {
    title: "Cursor",
    description:
      "Sets the cursor style on hover, providing visual feedback for interactive elements.",
    icon: "arrow-pointer",
    link: "/global_props/cursor",
  },
  {
    title: "Dark",
    description:
      "Applies a dark theme to elements, adjusting colors and contrast for a darker UI.",
    icon: "moon",
    link: "/global_props/dark",
  },
  {
    title: "Display",
    description:
      "Manages element display type, toggling visibility and layout between block, inline, or none.",
    icon: "eye",
    link: "/global_props/display",
  },
  {
    title: "Flex Box",
    description:
      "Implements flexible layouts, aligning and distributing space among items in a container.",
    icon: "objects-column",
    link: "/global_props/flex_box",
  },
  {
    title: "Justify (Flex Box)",
    description:
      "Controls how items are distributed within a Flex Box container. This can be horizontal or vertical spacing depending on the flex direction.",
    icon: "objects-align-center-vertical",
    link: "/global_props/flex_box_justify",
  },
  {
    title: "Align (Flex Box)",
    description:
      "Controls alignment of items within a Flex Box container. This can be vertical or horizontal alignment depending on the flex direction.",
    icon: "objects-align-left",
    link: "/global_props/flex_box_align",
  },
  {
    title: "Order (Flex Box)",
    description:
      "Changes the order of items within a Flex Box container, overriding the default source order.",
    icon: "list-ol",
    link: "/global_props/flex_box_order",
  },
  {
    title: "Gap (Flex Box)",
    description:
      "Sets the gap between items in a Flex Box container, controlling space distribution.",
    icon: "gap",
    link: "/global_props/flex_box_gap",
  },
  {
    title: "Grid",
    description:
      "Implements two-dimensional CSS Grid layouts with template, placement, and alignment props.",
    icon: "grid-2",
    link: "/global_props/grid",
  },
  {
    title: "Placement (Grid)",
    description:
      "Positions items within a Grid using column, row, and area placement props.",
    icon: "table-columns",
    link: "/global_props/grid_placement",
  },
  {
    title: "Align (Grid)",
    description:
      "Controls how grid items align within their cells using justifyItems and alignItems.",
    icon: "objects-align-left",
    link: "/global_props/grid_align",
  },
  {
    title: "Gap (Grid)",
    description:
      "Sets spacing between grid tracks with gap, rowGap, and columnGap.",
    icon: "gap",
    link: "/global_props/grid_gap",
  },
  {
    title: "Height",
    description:
      "Sets fixed or responsive height values for consistent vertical sizing.",
    icon: "arrows-up-down",
    link: "/global_props/height",
  },
  {
    title: "Hover",
    description:
      "Changes element appearance on hover, allowing background, shadows, and scale adjustments.",
    icon: "helicopter-symbol",
    link: "/global_props/hover",
  },
  {
    title: "HTML Options",
    description:
      "Customizes HTML attributes like id, class, and data attributes for better element control.",
    icon: "code",
    link: "/global_props/html_options",
  },
  {
    title: "Line Height",
    description:
      "Adjusts the vertical spacing between lines of text, with options like “tight,” “normal,” or “loose.”",
    icon: "line-height",
    link: "/global_props/line_height",
  },
  {
    title: "Margin",
    description:
      "Sets the outer spacing of elements, controlling distance between them and surrounding content.",
    icon: "border-outer",
    link: "/global_props/margin",
  },
  {
    title: "Max Height",
    description:
      "Sets an upper limit on an element’s height to maintain layout constraints.",
    icon: "arrows-up-down-to-line",
    link: "/global_props/max_height",
  },
  {
    title: "Max Width",
    description:
      "Restricts the maximum width of an element, ensuring responsive and consistent layouts.",
    icon: "arrows-left-right-to-line",
    link: "/global_props/max_width",
  },
  {
    title: "Min Height",
    description:
      "Ensures a minimum vertical space, preventing content from collapsing too small.",
    icon: "arrows-up-down-through-line",
    link: "/global_props/min_height",
  },
  {
    title: "Min Width",
    description:
      "Defines the smallest width an element can have, maintaining layout consistency and flexibility.",
    icon: "arrows-left-right-through-line",
    link: "/global_props/min_width",
  },
  {
    title: "Number Spacing",
    description:
      "Adjusts space between numerical characters for better readability and visual alignment.",
    icon: "tally-4",
    link: "/global_props/number_spacing",
  },
  {
    title: "Overflow",
    description:
      "Controls content overflow, determining whether hidden, scroll, or visible within boundaries.",
    icon: "arrow-down-up-across-line",
    link: "/global_props/overflow",
  },
  {
    title: "Padding",
    description:
      "Defines the inner spacing of an element, adjusting space between content and its border.",
    icon: "border-inner",
    link: "/global_props/padding",
  },
  {
    title: "Position",
    description:
      "Sets element positioning relative to its parent or the viewport, including fixed and absolute.",
    icon: "up-down-left-right",
    link: "/global_props/position",
  },
  {
    title: "Text Align",
    description:
      "Aligns text horizontally within a block, supporting left, right, center, or justified alignment.",
    icon: "align-left",
    link: "/global_props/text_align",
  },
  {
    title: "Truncate",
    description:
      "Shortens text to fit within a container, adding ellipsis to the end to indicate truncated content.",
    icon: "ellipsis",
    link: "/global_props/truncate",
  },
  {
    title: "Vertical Align",
    description:
      "Easily adjusts vertical alignment for elements like inline text where Flex Box support is limited.",
    icon: "objects-align-top",
    link: "/global_props/vertical_align",
  },
  {
    title: "Width",
    description:
      "Sets fixed or responsive width values for consistent horizontal sizing.",
    icon: "rectangle-wide",
    link: "/global_props/width",
  },
  {
    title: "Z-Index",
    description:
      "Adjusts stacking order of elements, controlling which elements appear on top or below others.",
    icon: "bring-front",
    link: "/global_props/z_index",
  },
  {
    title: "Border Radius",
    description:
      "Applies rounded corners to elements, enhancing visual appeal and softening edges.",
    icon: "draw-square",
    link: "/global_props/border_radius", 
  },
  {
    title: "Group Hover",
    description:
    "Enables hover effects on child elements when the parent element is hovered over.",
    icon: "layer-group",
    link: "/global_props/group_hover",
  },
  {
    title: "Shadow",
    description:
    "Applies depth effects using box shadows to elevate components visually and create visual hierarchy.",
    icon: "shadow",
    link: "/global_props/shadow",
  },
  {
    title: "Border",
    description:
      "Applies specific border styles to all sides, individual sides, or horizontal and vertical axes.",
    icon: "border-all",
    link: "/global_props/border",
  }
];
